// Curated heritage imagery for the Clan Donald site.
export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1651145447227-0f25b95f119a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920",
  heroBgDark:
    "https://images.pexels.com/photos/38805741/pexels-photo-38805741.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  bridgeCastle:
    "https://images.unsplash.com/photo-1736771676122-0b9c9b75e17c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  foggyCastle:
    "https://images.pexels.com/photos/10691831/pexels-photo-10691831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  glencoeHouse:
    "https://images.pexels.com/photos/31300998/pexels-photo-31300998.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  castleRuin:
    "https://images.pexels.com/photos/34961292/pexels-photo-34961292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  irishCoast:
    "https://images.pexels.com/photos/34930227/pexels-photo-34930227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  cliffs:
    "https://images.pexels.com/photos/33893284/pexels-photo-33893284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  tartan:
    "https://images.pexels.com/photos/5908367/pexels-photo-5908367.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
};
